import PlanSalesService from "@/api/services/planSales";
import { toCamelCase } from "@estaly/ui";

const initialState = {
  isLoading: false,
  plans: [],
};

export default {
  namespaced: true,

  state: initialState,

  mutations: {
    setPlans(state, plans) {
      state.plans = plans;
    },

    setIsLoading(state, val) {
      state.isLoading = val;
    },

    resetState(state) {
      state.isLoading = initialState.isLoading;
      state.plans = initialState.plans;
    },
  },

  getters: {
    hasInsurancePlan: (state) => {
      return state.plans?.some((plan) => plan.contractType === "insurance");
    },
  },

  actions: {
    reinitializeCustomerState({ commit }) {
      commit("resetState");
    },

    withLoader({ commit }, action) {
      commit("setIsLoading", true);
      return action().finally(() => {
        commit("setIsLoading", false);
      });
    },

    async getPlan(_, friendlyId) {
      return await PlanSalesService.getPlan(friendlyId);
    },

    async getPlans({ commit, dispatch }) {
      return dispatch("withLoader", async () => {
        const response = await PlanSalesService.getPlans();
        if (response?.success) {
          const { records = [] } = response.data || {};
          commit("setPlans", toCamelCase(records));
        }
        return response;
      });
    },
  },
};
